var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpandLeftbarArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    filter: "url(#filter0_b_4341_11446)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 0 24)",
    fill: "#515151",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "arrow",
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0532 12.0009L14.551 7.46527C14.8839 7.12914 14.8839 6.58702 14.551 6.25089C14.3924 6.09032 14.176 6 13.9503 6C13.7247 6 13.5083 6.09032 13.3497 6.25089L8.2512 11.3928C7.91724 11.7286 7.91724 12.2714 8.2512 12.6072L13.3495 17.7491C13.5083 17.9097 13.7247 18 13.9503 18C14.176 18 14.3924 17.9097 14.5512 17.7491C14.8839 17.4129 14.8839 16.8708 14.5508 16.5347L10.0532 12.0009Z",
    fill: "url(#paint0_radial_4341_11446)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0532 12.0009L14.551 7.46527C14.8839 7.12914 14.8839 6.58702 14.551 6.25089C14.3924 6.09032 14.176 6 13.9503 6C13.7247 6 13.5083 6.09032 13.3497 6.25089L8.2512 11.3928C7.91724 11.7286 7.91724 12.2714 8.2512 12.6072L13.3495 17.7491C13.5083 17.9097 13.7247 18 13.9503 18C14.176 18 14.3924 17.9097 14.5512 17.7491C14.8839 17.4129 14.8839 16.8708 14.5508 16.5347L10.0532 12.0009Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0532 12.0009L14.551 7.46527C14.8839 7.12914 14.8839 6.58702 14.551 6.25089C14.3924 6.09032 14.176 6 13.9503 6C13.7247 6 13.5083 6.09032 13.3497 6.25089L8.2512 11.3928C7.91724 11.7286 7.91724 12.2714 8.2512 12.6072L13.3495 17.7491C13.5083 17.9097 13.7247 18 13.9503 18C14.176 18 14.3924 17.9097 14.5512 17.7491C14.8839 17.4129 14.8839 16.8708 14.5508 16.5347L10.0532 12.0009Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 23.75,
    width: 23.5,
    height: 23.5,
    rx: 11.75,
    transform: "rotate(-90 0.25 23.75)",
    stroke: "url(#paint1_radial_4341_11446)",
    strokeOpacity: 0.48,
    strokeWidth: 0.5,
    style: {
      mixBlendMode: "lighten"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4341_11446",
    x: -180,
    y: -180,
    width: 384,
    height: 384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 90
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4341_11446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4341_11446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4341_11446",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4008 12) rotate(-180) scale(3.4 6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A33B3B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4341_11446",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 24) rotate(45) scale(33.9411 18.7083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#828282"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLeftbarArrow);
export default __webpack_public_path__ + "static/media/expand-leftbar-arrow.f2f19f75370db15d7aeb677f6eac7b06.svg";
export { ForwardRef as ReactComponent };